// extracted by mini-css-extract-plugin
export default {"blockWrapper":"hrZw7","inverted":"IQkta","light":"sfMHZ","blockTitle":"i_sIa","quizAnswer":"lX6Xl","countText":"kSmod","content":"neK28"};